import React from 'react'
import baseStyles from './Base.module.css'
import PageStatus from '../PageStatus'
import Student from '../Student'
import { isComem, isHeg } from '../lib/utils'
import { applyTo, always, cond, T, allPass } from 'ramda'
import './JourneeAccueil.css'
import { Link } from '@reach/router'

/*
const EcgGerman = () => (
    <>
        <p>Vendredi 10 septembre 2021 à l'AULA de la Rte de Cheseaux 1</p>
        <p>Programme :</p>
        <ul>
            <li>08h30 – 09h30 - Aula - Mot de bienvenue de la direction de la HEIG-VD</li>
            <li>10h15 – 11h30 - G01 - Informations de votre chef de département et de votre responsable de filière</li>
            <li>13h00 – 13h50 - G01 - Informations au sujet de l'enseignement de l'Allemand</li>
            <li>14h15 – 15h30 - Aula - Présentation de la bibliothèque et du service informatique</li>
        </ul>
        <ul>
            <li>
                09h30 - 10h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                11h30 - 12h45 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                15h30 - 17h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
        </ul>
    </>
)

const EcgEnglish = () => (
    <>
        <p>Vendredi 10 septembre 2021 à l'AULA de la Rte de Cheseaux 1</p>
        <p>Programme :</p>
        <ul>
            <li>08h30 – 09h30 - Aula - Mot de bienvenue de la direction de la HEIG-VD</li>
            <li>10h15 – 11h30 - G01 - Informations de votre chef de département et de votre responsable de filière</li>
            <li>13h00 – 13h50 - Aula - Informations au sujet de l'enseignement de l'Anglais</li>
            <li>14h15 – 15h30 - Aula - Présentation de la bibliothèque et du service informatique</li>
        </ul>
        <ul>
            <li>
                09h30 - 10h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                11h30 - 12h45 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                15h30 - 17h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
        </ul>
    </>
)

const Tic = () => (
    <>
        <p>Vendredi 10 septembre 2021 à l'AULA de la Rte de Cheseaux 1</p>
        <p>Programme :</p>
        <ul>
            <li>08h30 – 09h30 - Aula - Mot de bienvenue de la direction de la HEIG-VD</li>
            <li>10h15 – 11h30 - F01 - Informations de votre chef de département et de votre responsable de filière</li>
            <li>13h00 – 13h50 - Aula - Informations de l'enseignement de l'Anglais</li>
            <li>14h15 – 15h30 - Aula - Présentation de la bibliothèque et du service informatique</li>
        </ul>
        <ul>
            <li>
                09h30 - 10h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                11h30 - 12h45 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                15h30 - 17h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
        </ul>
    </>
)

const TinGerman = () => (
    <>
        <p>Vendredi 10 septembre 2021 à l'AULA de la Rte de Cheseaux 1</p>
        <p>Programme :</p>
        <ul>
            <li>08h30 – 09h30 - Aula - Mot de bienvenue de la direction de la HEIG-VD</li>
            <li>10h15 – 11h30 - Aula - Informations de votre chef de département et de votre responsable de filière</li>
            <li>13h00 – 13h50 - G01 - Informations de l'enseignement de l'Allemand</li>
            <li>14h15 – 15h30 - Aula - Présentation de la bibliothèque et du service informatique</li>
        </ul>
        <ul>
            <li>
                09h30 - 10h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                11h30 - 12h45 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                15h30 - 17h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
        </ul>
    </>
)

const TinEnglish = () => (
    <>
        <p>Vendredi 10 septembre 2021 à l'AULA de la Rte de Cheseaux 1</p>
        <p>Programme :</p>
        <ul>
            <li>08h30 – 09h30 - Aula - Mot de bienvenue de la direction de la HEIG-VD</li>
            <li>10h15 – 11h30 - Aula - Informations de votre chef de département et de votre responsable de filière</li>
            <li>13h00 – 13h50 - Aula - Informations de l'enseignement de l'Anglais</li>
            <li>14h15 – 15h30 - Aula - Présentation de la bibliothèque et du service informatique</li>
        </ul>
        <ul>
            <li>
                09h30 - 10h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                11h30 - 12h45 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
            <li>
                15h30 - 17h00 - F04 - Etudiant-e-s qui doivent encore être immatriculé-e-s ou apporter des documents
            </li>
        </ul>
    </>
)

const Comem = () => (
    <>
        <p>Vendredi 10 septembre 2021 à l&#39;AULA de la Rte de Cheseaux 1</p>
        <p>Programme :</p>
        <ul>
            <li>08h30 – 09h30 - Aula - Mot de bienvenue de la direction de la HEIG-VD</li>
            <li>10h00 – 11h00 - A01 - Informations de votre chef de département</li>
            <li>11h00 – 13h00 - Pause</li>
            <li>13h00 – 13h50 - Aula - Informations de l&#39;enseignement de l&#39;Anglais</li>
            <li>14h15 – 15h30 - Aula - Présentation de la bibliothèque et du service informatique</li>
        </ul>
    </>
)

const Heg = () => (
    <>
        <p>Jeudi 9 septembre 2021 à l'AULA de la Rte de Cheseaux 1</p>
        <p>Programme :</p>
        <ul>
            <li>08h30 – 10h00 - Site de Cheseaux (Aula) - Accueil des étudiants</li>
            <li>10h00 – 10h30 - Site Cheseaux - Enclassement (formation des classes)</li>
            <li>10h30 – 11h15 - Site Cheseaux - Visite Site de Cheseaux</li>
            <li>11h15 – 12h00 - Site St-Roch - Déplacement direction Site de St-Roch et visite de St-Roch</li>
            <li>12h00 - 13h00 - Cafétéria - Apéritif général sur le Site de St-Roch</li>
        </ul>
        <ul>
            <li>13h00 - 17h00 - S106 - Suite des immatriculation</li>
            <li>13h00 - 17h00 - S107 - Distribution calculettes + Livres professeur-e-s</li>
            <li>Dès 15h00 - Librairie Payot - Ventes livres</li>
        </ul>
    </>
)

const Fallback = () => <p>Cette rebrique est vide pour l'inscription que vous avez choisie.</p>

*/

const Comem = () => (
    <>
        <p>
            <strong>Jeudi 10 septembre 2026 de 10 h 15 à 16 h 00 (présence obligatoire)</strong>
        </p>
        <p>
            <strong>Lieu de rendez-vous</strong>: HEIG-VD, Aula, Route de Cheseaux 1, 1400 Yverdon-les-Bains
        </p>
        <p>
            Pour vous rendre à notre Journée d'accueil, nous vous encourageons à utiliser les <strong>transports en commun.</strong>
        </p>
        <p>
            La participation à notre <strong>Journée d'accueil est obligatoire</strong>, nous vous invitons donc à réserver cette journée dans votre agenda. De nombreuses informations pratiques vous seront en effet communiquées à cette occasion afin de débuter dans les meilleures conditions., nous vous invitons donc à réserver cette journée dans votre agenda. De nombreuses informations pratiques vous seront en effet communiquées à cette occasion afin de débuter dans les meilleures conditions.
        </p>
        <p>
            Pour votre repas de midi,{' '}
            <a
                href="https://intra.heig-vd.ch/campus/cafeterias/Pages/menusetprix.aspx"
                target="_blank"
                rel="noopener noreferrer"
            >
                la Cafétéria
            </a>{' '} propose des menus dès CHF 9.80, dont un végétarien. Il y a également de la petite restauration, assiette de pâtes ou vous pouvez apporter votre repas ; des fours à micro-ondes sont disponibles. De plus, ce jour-là, l’AGE met des grils à disposition. Vous pouvez soit, acheter vos salades ainsi que vos grillades à la Cafétéria, soit en apporter. <span style={{ color: 'red' }}>L’école offre également un bon de CHF 5.- valable le jour même à la Cafétéria.</span>
        </p>
        <p><strong>Programme</strong></p>
        <table class="journee-accueil-table">
            <tr>
                <td>10h15 – 12h00</td>
                <td>Accueil café-croissant<br />Bienvenue de la Direction de l’école <br />Informations générales sur la vie à la HEIG-VD</td>
            </tr>
            <tr>
                <td>12h00 – 13h30</td>
                <td> Temps de repas <br />
                    Découverte de la vie associative de l’école</td>
            </tr>
            <tr>
                <td>13h30 – 16h00</td>
                <td>Plongez au cœur de votre filière et de la vie étudiante !</td>
            </tr>
        </table>
    </>
)

const Heg = () => (
    <>
        <p>
            <strong>Jeudi 10 septembre 2026 de 8 h 00 à 15 h 30 (présence obligatoire)</strong>
        </p>
        <p style={{ textAlign: 'center', color: 'red' }}><strong>
            N'oubliez pas de prendre votre {' '}
            <Link to="/2026/ordinateur-portable">ordinateur portable</Link>.
        </strong></p>
        <p>
            <strong>Lieu de rendez-vous</strong>: HEIG-VD, Aula, Route de Cheseaux 1, 1400 Yverdon-les-Bains
        </p>
        <p>
            Pour vous rendre à notre Journée d'accueil, nous vous encourageons à utiliser les <strong>transports en commun.</strong>
        </p>
        <p>
            La participation à notre <strong>Journée d'accueil est obligatoire</strong>, nous vous invitons donc à réserver cette journée dans votre agenda. De nombreuses informations pratiques vous seront en effet communiquées à cette occasion afin de débuter dans les meilleures conditions.
        </p>
        <p>Le <strong>repas de midi est offert par l’École</strong></p>
        <p><strong>Programme à venir</strong></p>
    </>
)

const Fallback = () => (
    <>
        <p>
            <strong>Jeudi 10 septembre 2026, de 10 h 15 à 16 h 00 (présence obligatoire)</strong>
        </p>
        <p style={{ textAlign: 'center', color: 'red' }}>
            <strong>
                N'oubliez pas de prendre votre <Link to="/2026/ordinateur-portable">ordinateur portable</Link>.
            </strong>
        </p>
        <p>
            <strong>Lieu de rendez-vous</strong>: HEIG-VD, Aula, Route de Cheseaux 1, 1400 Yverdon-les-Bains
        </p>
        <p>
            Pour vous rendre à notre Journée d'accueil, nous vous encourageons à utiliser les{' '}
            <strong>transports en commun.</strong>
        </p>
        <p>
            La participation à notre <strong>Journée d'accueil est obligatoire</strong>, nous vous invitons donc à
            réserver cette journée dans votre agenda. De nombreuses informations pratiques vous seront en effet
            communiquées à cette occasion afin de débuter dans les meilleures conditions.
        </p>
        <p>
            Pour votre repas de midi,{' '}
            <a
                href="https://intra.heig-vd.ch/campus/cafeterias/Pages/menusetprix.aspx"
                target="_blank"
                rel="noopener noreferrer"
            >
                la Cafétéria
            </a>{' '}
            propose des menus dès CHF 9.80, dont un végétarien. Il y a également de la petite restauration, assiette de
            pâtes ou vous pouvez apporter votre repas ; des fours à micro-ondes sont disponibles. De plus, ce jour-là,
            l’AGE met des grils à disposition. Vous pouvez soit, acheter vos salades ainsi que vos grillades à la
            Cafétéria, soit en apporter.{' '}
            <span style={{ color: 'red' }}>
                L’école offre également un bon de CHF 5.- valable le jour même à la Cafétéria.
            </span>
        </p>
        <p>
            <strong>Programme</strong>
        </p>
        <table class="journee-accueil-table">
            <tr>
                <td>10h15 – 12h00</td>
                <td>
                    Accueil café-croissant<br/>
                    Bienvenue de la Direction de l’école <br />
                    Informations générales sur la vie à la HEIG-VD
                </td>
            </tr>
            <tr>
                <td>12h00 – 13h30</td>
                <td>
                    {' '}
                    Temps de repas <br /> Atelier de <strong>préparation des ordinateurs portables</strong> Découverte
                    de la vie associative de l’école
                </td>
            </tr>
            <tr>
                <td>13h30 – 16h00</td>
                <td>Plongez au cœur de votre filière et de la vie étudiante !</td>
            </tr>
        </table>
    </>
)

export default ({ path }) => {
    const { student } = Student.useContainer()

    return (
        <div className={baseStyles.root}>
            <h2>Journée d’accueil - Présence obligatoire</h2>
            <PageStatus path={path} label="J'ai réservé la date dans mon agenda" />
            {applyTo(
                student,
                cond([
                    [allPass([isComem]), always(<Comem />)],
                    [allPass([isHeg]), always(<Heg />)],
                    [T, always(<Fallback />)],
                ])
            )}
        </div>
    )
}
